import React, { Component } from 'react';
import { Alert, Container, Row, Form, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import { Link } from 'react-router-dom';
import trivvyLogo from "../../assets/trivvy/trivvy-logo-img.png";
import axios from '../../axios';
import './Login.css';
import { validateEmail } from './../../utils/validations';
import Logo  from '../../components/Logo/Logo';
import LoginSide from '../../components/LoginSide/LoginSide';
import * as url from '../../utils/url';
import { isTrivvyProduct } from '../../utils/constants';

class ResetPassword extends Component {

	constructor(props) {
		super(props);
		this.state = {
			email: {
				value: null,
				error: false
			},
			errorMessage: ''
		}
	}

	handleEmailChange = ({ target }) => {
		const { value } = target;
		const { email } = this.state;
		email.value = value;
		email.error = false;
		this.setState({
			email
		});
	}

	handleSendResetLink = () => {
		const emailValue = this.state.email.value;
		const isValidEmail = validateEmail(emailValue);
		if (!isValidEmail) {
			this.setState({
				email: {
					value: emailValue,
					error: !isValidEmail
				}
			})
		}
		if (isValidEmail) {
			axios.post(url.requestPasswordLink, { email: this.state.email.value }).then(() => {
				this.props.history.replace('/reset-link-sent');
			}).catch((error) => {
				this.setState({ ...this.state, errorMessage: error.response.data });
			})
		}
	}

	render() {
		const fromTrivvy = isTrivvyProduct() || window.location.href.includes("fromTrivvy");
		let alert = null;
		let { email, errorMessage } = this.state;
		if (errorMessage) {
			alert = (
				<div className="alert-msg-bg mt50">
					<i className="close-icon" onClick={() => this.setState({ errorMessage: undefined })}>close</i>
					<div className="d-flex custom-message-box">
						<i className="material-icons alert-icon-bg">remove_circle</i>
						<span className="ml10 alert-msg-text">{errorMessage}</span>
					</div>
				</div>)
		}
		return (
			<Container className="login-layout-container">
				<Row className="login-outer-wrapper">
					<div id="login-main" className="col-sm-10 col-md-10 login-card-box">
						<div id="login-main-wrapper" 
						   className={`white-background ${fromTrivvy && "forgot-pass-trivvy"}`}>
							   {
								   isTrivvyProduct() ? <div className="login-container-title-trivvy"> 
								   {/* <img src={trivvyLogo} className="trivvy-logo-img" /> */}
								   <span
								  className="sidebar-trivvy-logo-txt-lg"
								>
								  Trivvy
								</span>
								   </div>:	<Logo />
							   }
						
							<div className="text-left mt50 reset-password-title">
								Reset your password
							</div>
							<div className="text-left mt10 reset-password-desc">
								Enter the email address associated with your {fromTrivvy ? "Trivvy":"OurOffice"}  account
								and we’ll send you a reset link.
							</div>
							{alert}
							<Form className="mt30">
								<FormGroup>
									<Label for="email" className="label-login-email">Email Address</Label>
									<Input
										type="email"
										name="email"
										id="email"
										className="inputBox-height"
										onChange={this.handleEmailChange}
										invalid={email.error}
									/>
									<FormFeedback>Please enter valid email address.</FormFeedback>
								</FormGroup>
								<div className="text-center mt30">
									<Button onClick={this.handleSendResetLink} className="btn-send-reset-link"><span className="txt-send-reset-link">
										Reset Password
									</span></Button>
								</div>
								<div className="text-center mt30">
									<Link to={'/login'} className="link-go-back">Wait, I remember. Take me back!</Link>
								</div>
							</Form>
						</div>
					</div>
					{!fromTrivvy && <LoginSide />}
				</Row>
				<Row>
					<div id="login-secondary" className="col-sm-12 mb10 pl30">
					<div className="text-center">
              © {new Date().getFullYear()}{" "}
              {fromTrivvy ? (
                <a href="https://www.gotrivvy.com/">Trivvy</a>
              ) : (
                <a href="https://www.ouroffice.io/">OurOffice, Inc</a>
              )}
            </div>
					</div>
				</Row>
			</Container>
		)
	}
}

export default ResetPassword;